// API URL für die Entwicklungsumgebung
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080"

// Haufe Treo Company ID
export const HAUFE_COMPANY_ID = process.env.REACT_APP_HAUFE_COMPANY_ID || "Test"
